<template>
  <div
    class="sidebar-disclosure"
    @keyup="evaluateEscape"
  >
    <button
      v-if="!isLarge"
      :aria-expanded="expanded"
      :class="{ 'sidebar-disclosure__button--expanded' : expanded }"
      class="sidebar-disclosure__button"
      aria-controls="sidebar-disclosure__panel"
      @click="toggleExpanded"
    >
      {{ buttonText }}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 12"
        class="sidebar-disclosure__button-icon"
      >
        <path d="M5.121 11.121L3 9l2.939-2.939L3 3.121 5.121 1l5.061 5.061-5.061 5.06z"/>
      </svg>
    </button>
    <TransitionHeight>
      <div
        v-show="disclosureVisible"
        id="sidebar-disclosure__panel"
        class="sidebar-disclosure__panel"
      >
        <slot />
      </div>
    </TransitionHeight>
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: 'In This Section',
    },
    isLarge: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    disclosureVisible() {
      if (this.isLarge) {
        return true
      }
      return this.expanded
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
    },
    evaluateEscape({ keyCode }) {
      if (keyCode !== 27) {
        return
      }

      this.expanded = false
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/components/SidebarDisclosure.vue